module.exports = __webpack_public_path__ + "media/ghoul.ed9cc799.mp3";